export default "__VITE_ASSET__J3_AMLTs__"